if (
  typeof Number !== undefined
  && Number.prototype
  && !Number.prototype.ordinal
) {
  Object.defineProperty(Number.prototype, 'ordinal', {
    value() {
      return `${this}${[,'st','nd','rd'][this/10%10^1&&this%10] || 'th'}`;
    }
  });
}